import { AxiosResponse } from 'axios';

import { APIClients, getAxiosResponseData } from '../api-client';
import { API_PATHS } from '../app-core';
import { WSC_API_URL } from '../app-core/config';
import { CurrentUserCheck } from '../authenticator/auth0/types';

export const OPTIONAL_BASE_URL = WSC_API_URL && { baseURL: WSC_API_URL };

interface ValidateUserResponse {
  redirect: boolean;
  existing: boolean;
}

/**
 * Validates entered user email. Depending on redirect flag of response, user will be redirected to additional auth page
 */
export const validateUserEmail = async (email: string): Promise<ValidateUserResponse> => {
  const response = await APIClients.getAPIClient().makePublicRequest({
    payload: {
      request: {
        ...OPTIONAL_BASE_URL,
        method: 'POST',
        data: { email_address: email },
        url: API_PATHS.USERS_VALIDATE
      }
    }
  });
  return getAxiosResponseData<ValidateUserResponse>(response as AxiosResponse<ValidateUserResponse>);
};

/**
 * Checks currently authenticated user
 */
export const checkCurrentUser = async (): Promise<CurrentUserCheck> => {
  const response = await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        url: API_PATHS.USERS_CURRENT
      }
    }
  });
  return getAxiosResponseData<CurrentUserCheck>(response as AxiosResponse<CurrentUserCheck>);
};

export const triggerLoginSuccessEvent = async () => {
  return await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        method: 'PATCH',
        url: API_PATHS.USERS_CURRENT_LOGIN_EVENT
      }
    }
  });
};

export const updateCurrentUser = async (data: Record<string, string>): Promise<CurrentUserCheck> => {
  const response = await APIClients.getAPIClient().makeRequest({
    payload: {
      request: {
        method: 'PATCH',
        data: { ...data },
        url: API_PATHS.USERS_CURRENT
      }
    }
  });
  return getAxiosResponseData<CurrentUserCheck>(response as AxiosResponse<CurrentUserCheck>);
};
